import React from 'react';
import { useAudioStore } from '../../stores/audioStore';

const EnableSoundButton = () => {
  const { isMuted, toggleMute } = useAudioStore();

  const handleClick = () => {
    toggleMute(); // This will unmute and unlock audio
  };

  // Only show when muted
  if (!isMuted) {
    return null;
  }

  return (
    <div className="enable-sound-overlay fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center">
        <div className="mb-6">
          <div className="text-6xl mb-4">🔊</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Enable AURA's Voice
          </h2>
          <p className="text-gray-600">
            Click the button below to enable AURA's voice assistant. This allows AURA to speak market updates and respond to your questions.
          </p>
        </div>
        <button
          onClick={handleClick}
          className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-all transform hover:scale-105 shadow-lg"
        >
          🔊 Enable Sound
        </button>
        <p className="text-xs text-gray-500 mt-4">
          Your browser requires user interaction to enable audio playback
        </p>
      </div>
    </div>
  );
};

export default EnableSoundButton;
